export enum TipoAerocombustible {
    Indeterminado= 0,
    Nafta= 1,
    Kerosene= 2,
}
